window.Vue = require('vue');
_ = require('lodash');

import VTooltip from 'v-tooltip';
Vue.use(VTooltip);

// gets imported once in frontend.js to prevent errors
Vue.use(window.VueRouter);

/* FLARE */
import { flare } from "@flareapp/flare-client";
import { flareVue } from "@flareapp/flare-vue";

if (process.env.NODE_ENV === 'production') {
    if(window.sharedData !== undefined && window.sharedData.flare_js_key !== undefined) {
        if(window.sharedData.flare_js_key !== null && window.sharedData.flare_js_key.length !== 0) {
            flare.light(window.sharedData.flare_js_key);
        }
    }
}

Vue.use(flareVue);


function _get(target, key, force) {

    target = target || null;
    key = key || null;
    force = force || false;

    if(key === null) {
        if(!target) {
            return (force) ? '--' : '';
        } else {
            return target;
        }
    }

    if( typeof target === 'undefined' || typeof key === 'undefined' || !(key in target) || typeof target[key] === 'undefined' || target[key] === '' ) {
        return (force) ? '--' : '';
    } else {
        return target[key];
    }
}

const money = new Intl.NumberFormat('de-DE',
    { style:'currency', currency: 'EUR' });

function _num(num, dec, suf, pre) {

    num = parseInt(num) || 0;
    dec = dec || 0;
    suf = suf || '';
    pre = pre || '';

    num = num.format(dec, null, '.', ',');

    return pre + num + suf;
}

window.base_price = window.atob(window.sharedData.lp_price);
window.price_total_calculated = window.base_price;

if(typeof window.sharedData !== 'undefined' && typeof window.sharedData.lp_name !== 'undefined') {

    const TIMEOUT = 1;

    const router = new VueRouter({
        mode: 'history',
        base: __dirname,
        routes: []
    });

    const global_price_total_calculated = Vue.observable({ global_price_total_calculated: {} })

    Object.defineProperty(Vue.prototype, '$global_price_total_calculated', {
        get () {
            return global_price_total_calculated.global_price_total_calculated
        },

        set (value) {
            global_price_total_calculated.global_price_total_calculated = value
        }
    })

    const appHeader = new Vue({
        router,
        el: '#landingpageVueAppHeader',
        data() {
            return {
                lp_name: window.sharedData.lp_name,
                lp_price_calculated: window.base_price,
                lp_group: window.sharedData.lp_group,
            }
        },
        watch: {
            $global_price_total_calculated () {
                this.lp_price_calculated = this.$global_price_total_calculated;

                if(document.getElementById("lp_calculated_price") !== null) {
                    document.getElementById("lp_calculated_price").value = window.btoa(this.$global_price_total_calculated);
                }
                // console.log('price has changed for header and form');
            }
        },
        mounted() {
            if (this.$route.hash) {
                setTimeout(() => this.scrollTo(this.$route.hash), TIMEOUT)
            }
        },
        methods : {
            formatPreis: function(preis) {
                if(typeof window.sharedData.lp_group !== 'undefined' && window.sharedData.lp_group === 'commercial') {
                    return money.format(preis)+' (netto)';
                }
                return money.format(preis);
            },

            scrollTo: function (hashtag) {
                if(hashtag !== '' && hashtag !== undefined) {
                    var elem = $(hashtag);

                    if(elem !== undefined) {
                        $('html,body').animate({
                            scrollTop: elem.offset().top - 150
                        }, 500);
                    }
                }
                // setTimeout(() => { location.href = hashtag }, TIMEOUT)
            }
        },
        computed: {
            landingpageCalculatedPriceString: function() {
                return this.formatPreis(this.lp_price_calculated);
            },

            landingpageAnchorString: function() {
                if(document.getElementById('landingpageButtonLink') !== null) {
                    return document.getElementById('landingpageButtonLink').innerHTML;
                }
                return '';
            },

            landingpagePriceString: function() {
                if(document.getElementById('landingpageButtonText') !== null) {
                    let priceString = document.getElementById('landingpageButtonText').innerHTML;
                    return priceString.replace('$$$', this.landingpageCalculatedPriceString);
                } else {
                    return this.landingpageCalculatedPriceString;
                }
            },

            landingpageNameString: function() {
                return this.lp_name;
            },
        },
    });

    const appButton = new Vue({
        router,
        el: '#landingpageVueAppButton',
        data() {
            return {
                lp_price_calculated: window.base_price,
            }
        },
        watch: {
            $global_price_total_calculated () {
                this.lp_price_calculated = this.$global_price_total_calculated;
                // console.log('price has changed for button');
            }
        },
        methods : {
            formatPreis: function(preis) {
                if(typeof window.sharedData.lp_group !== 'undefined' && window.sharedData.lp_group === 'commercial') {
                    return money.format(preis)+' (netto)';
                }
                return money.format(preis);
            },
        },
        computed: {
            landingpageCalculatedPriceString: function() {
                return this.formatPreis(this.lp_price_calculated);
            },

            landingpageButtonString: function() {
                if(document.getElementById('landingpageButtonText') !== null) {
                    let buttonString = document.getElementById('landingpageButtonText').innerHTML;
                    return buttonString.replace('$$$', this.landingpageCalculatedPriceString);
                } else {
                    return this.landingpageCalculatedPriceString;
                }
            },
        },
    });

    if(document.getElementById('landingpageVueAppAddons') !== null) {
        const appAddons = new Vue({
            router,
            el: '#landingpageVueAppAddons',
            data() {
                return {
                    addons: Object.assign([], JSON.parse(window.atob(window.sharedData.lp_addons))),
                }
            },
            mounted() {
                if (window.sharedData.lp_addons !== '{}') {

                    let addons_sum = 0.0;
                    this.addons.forEach((value, index) => {
                        if(value !== undefined) {
                            addons_sum+= parseFloat(value);
                        }
                    });

                    if(document.getElementById('lp_addons') !== null) {
                        document.getElementById('lp_addons').value = window.btoa(JSON.stringify(Object.assign({}, this.addons)));
                    }

                    // console.log(global_price_total_calculated);

                    this.$global_price_total_calculated = parseFloat(window.base_price) + addons_sum;
                }
            },
            methods: {
                add_addon: function(component_id, id, price, no = '') {
                    const labelAddon = document.getElementById('_label_addon_'+component_id+'_'+id);
                    const multiLabelAddon = document.getElementById('_label_addon_'+component_id+'_'+id+'_'+no);
                    //alert(this.addons[id] + ' (' + id + ') ' + ' =/= ' + price);

                    // remove all possible active addon text
                    document.querySelectorAll('.addon-choice').forEach(el => {
                        el.classList.remove('active');
                    });

                    if(this.addons[id] !== undefined) {

                        // check for price then replace or remove
                        if (this.addons[id] !== price) {
                            this.addons[id] = price;

                            if (labelAddon) {
                                labelAddon.classList.add('active');
                            }

                            if (multiLabelAddon) {
                                multiLabelAddon.classList.add('active');
                            }

                        } else {
                            //this.addons[id] = undefined;
                            delete this.addons[id];

                            if (labelAddon) {
                                labelAddon.classList.remove('active');
                            }

                            if (multiLabelAddon) {
                                multiLabelAddon.classList.remove('active');
                            }
                        }

                    } else {

                        this.addons[id] = price;

                        if (labelAddon) {
                            labelAddon.classList.add('active');
                        }

                        if (multiLabelAddon) {
                            multiLabelAddon.classList.add('active');
                        }

                    }

                    let addons_sum = 0.0;
                    this.addons.forEach((value, index) => {
                        if(value !== undefined) {
                            addons_sum+= parseFloat(value);
                        }
                    });

                    if(document.getElementById('lp_addons') !== null) {
                        document.getElementById('lp_addons').value = window.btoa(JSON.stringify(Object.assign({}, this.addons)));
                    }

                    // console.log(global_price_total_calculated);

                    this.$global_price_total_calculated = parseFloat(window.base_price) + addons_sum;
                    console.log(this.addons);
                },

                // onAddonClick: function(id) {
                //     console.log(id);
                //     let active_class = '';
                //
                //     this.addons.forEach((value, index) => {
                //         console.log(value, index);
                //         if(value !== undefined) {
                //
                //         }
                //     });
                // },
            },
            computed: {},
        });
    }
}


// WEBPACK FOOTER //
// ./resources/js/landingpage.js